
import React from 'react';
import { Modal } from '@weirgroup/weir-dls';
import './create-step-modal.scss';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../../../../components/loading-spinner';
import { useDarkMode } from '../../../../hooks/use-darkmode';

interface CreateStepModalProps {
  open: boolean;
  current: number;
  total: number;
  onClose: () => void;
  errorCount: number;
  continueDisabled?: boolean;
}

const CreateStepModal: React.FC<CreateStepModalProps> = ({ open, current, total, onClose, errorCount, continueDisabled }) => {
  const { t } = useTranslation();
  const {darkMode} = useDarkMode();
  return (
    <Modal showModal={open} onClose={onClose} size="small">
      <div className="create-step-modal-container">
        <div className="create-step-modal-title">
          {continueDisabled ? t("uploadAssets.createStepModal.creatingAsset") : t("uploadAssets.createStepModal.createdAsset")} {current}
          <span className="create-step-modal-subtitle">&nbsp;out of&nbsp;{total}</span>
          {continueDisabled ? "" : <span className="create-step-modal-subtitle">&nbsp;{t("uploadAssets.createStepModal.assets")}</span>}
        </div>
        {!continueDisabled && null}
        {continueDisabled && (
          <LoadingSpinner darkMode={darkMode} />
        )}
        {errorCount > 0 && (
          <div className="create-step-modal-error">
            {errorCount} failed
          </div>
        )}
        <button
          className="create-step-modal-continue-btn"
          onClick={onClose}
          disabled={continueDisabled}
          style={{ marginTop: '24px', padding: '8px 24px', fontSize: '1rem', borderRadius: '4px', background: continueDisabled ? '#b0b0b0' : '#1976d2', color: '#fff', border: 'none', cursor: continueDisabled ? 'not-allowed' : 'pointer' }}
        >
          Continue
        </button>
      </div>
    </Modal>
  );
};

export default CreateStepModal;
